const {actionTableKeys} = require('../../new-table/Constants')

export const columnList = [
    {field: 'name', header: 'Name', initialShown: true},
    {
        field: 'surgery',
        header: 'Surgery',
        body: rowData => rowData?.surgery || '-',
        initialShown: true,
    },
    {
        field: 'address',
        header: 'Address',
        body: rowData => rowData?.address || '-',
        initialShown: true,
    },
    {field: 'email', header: 'Email', initialShown: true},
    {field: 'createdAt', header: 'Created At', initialShown: true},
    // {
    //     field: actionTableKeys.action,
    //     header: 'Action',
    //     actionList: [actionTableKeys.edit, actionTableKeys.delete],
    //     initialShown: true,
    // },
]

export const generalPractitionerTableActions = [
    {
        key: actionTableKeys.delete,
        icon: <i className="pi pi-trash"></i>,
        label: 'Delete',
        severity: 'danger',
    },
    {
        key: actionTableKeys.edit,
        icon: <i className="pi pi-pencil"></i>,
        label: 'Edit',
        severity: 'normal',
    },
]
